export const environment = {
  production: false,
  API_END_POINT: 'https://beta.docquityclinic.id',
  indonesiaDomain: 'https://beta.dqcare.id',
  otherDomain: 'https://beta.dqcare.id',
  hCaptchaSiteKey: '10000000-ffff-ffff-ffff-000000000001',
  env : 'UAT',
  hideRelevantFilesPharma: ''
};
